module.exports = __webpack_public_path__ + "static/media/gcdef_10001.553ff168.ico";